/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { SearchTradeWaysRequest } from '../model/searchTradeWaysRequest';
// @ts-ignore
import { SyntheticRateRequest } from '../model/syntheticRateRequest';
// @ts-ignore
import { SyntheticRateResponse } from '../model/syntheticRateResponse';
// @ts-ignore
import { SyntheticTradeRequest } from '../model/syntheticTradeRequest';
// @ts-ignore
import { SyntheticTradeResponse } from '../model/syntheticTradeResponse';
// @ts-ignore
import { TradeWay } from '../model/tradeWay';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface RequestSyntheticTradeRequestParams {
  syntheticTradeRequest: SyntheticTradeRequest;
}

export interface RequestsRate1RequestParams {
  syntheticRateRequest: SyntheticRateRequest;
}

export interface RequestsTradeWaysRequestParams {
  searchTradeWaysRequest: SearchTradeWaysRequest;
}

@Injectable({
  providedIn: 'root',
})
export class SyntheticTradingControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Sends synthetic order
   * @endpoint post /v1/synthetic-trading/trade
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public requestSyntheticTrade(
    requestParameters: RequestSyntheticTradeRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<SyntheticTradeResponse>;
  public requestSyntheticTrade(
    requestParameters: RequestSyntheticTradeRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<SyntheticTradeResponse>>;
  public requestSyntheticTrade(
    requestParameters: RequestSyntheticTradeRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<SyntheticTradeResponse>>;
  public requestSyntheticTrade(
    requestParameters: RequestSyntheticTradeRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const syntheticTradeRequest = requestParameters?.syntheticTradeRequest;
    if (syntheticTradeRequest === null || syntheticTradeRequest === undefined) {
      throw new Error(
        'Required parameter syntheticTradeRequest was null or undefined when calling requestSyntheticTrade.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/synthetic-trading/trade`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SyntheticTradeResponse>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: syntheticTradeRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Request rate
   * @endpoint post /v1/synthetic-trading/rate
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public requestsRate1(
    requestParameters: RequestsRate1RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<SyntheticRateResponse>;
  public requestsRate1(
    requestParameters: RequestsRate1RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<SyntheticRateResponse>>;
  public requestsRate1(
    requestParameters: RequestsRate1RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<SyntheticRateResponse>>;
  public requestsRate1(
    requestParameters: RequestsRate1RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const syntheticRateRequest = requestParameters?.syntheticRateRequest;
    if (syntheticRateRequest === null || syntheticRateRequest === undefined) {
      throw new Error('Required parameter syntheticRateRequest was null or undefined when calling requestsRate1.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/synthetic-trading/rate`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SyntheticRateResponse>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: syntheticRateRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Request trade ways
   * @endpoint post /v1/synthetic-trading/trade-ways
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public requestsTradeWays(
    requestParameters: RequestsTradeWaysRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<TradeWay>>;
  public requestsTradeWays(
    requestParameters: RequestsTradeWaysRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<TradeWay>>>;
  public requestsTradeWays(
    requestParameters: RequestsTradeWaysRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<TradeWay>>>;
  public requestsTradeWays(
    requestParameters: RequestsTradeWaysRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const searchTradeWaysRequest = requestParameters?.searchTradeWaysRequest;
    if (searchTradeWaysRequest === null || searchTradeWaysRequest === undefined) {
      throw new Error(
        'Required parameter searchTradeWaysRequest was null or undefined when calling requestsTradeWays.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/synthetic-trading/trade-ways`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<TradeWay>>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: searchTradeWaysRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
